import React from 'react';
import {ReactComponent as PolkoLogo} from "../../assets/logos/polko.svg"
import "./Footer.css"

function Footer() {
    return (
        <footer className="footer">
            <span className="footer__poweredBy">Powered by</span>
            <PolkoLogo className="footer__logo" aria-label="polko"/>
        </footer>
    );
}

export default Footer;
